import clsx from "clsx";
import React, { useState } from "react";
import LoadingSpinnerInline from "../../../../components/common/loading-spinner/loading-spinner-inline";

type DeleteConfirmationModalProps = {
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  onClose,
  onConfirm,
}) => {
  const [buttonBlockStyle, setButtonBlockStyle] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setButtonBlockStyle("pointer-events-none opacity-80");
    setIsLoading(true);
    await onConfirm();
    setIsLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg w-80">
        <h2 className="text-3xl font-semibold mb-4">메뉴 삭제</h2>
        <p className="text-2xl mb-6">정말로 이 메뉴를 삭제하시겠습니까?</p>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="text-2xl px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            취소
          </button>
          <button
            onClick={handleClick}
            className={clsx(
              "text-2xl px-4 py-2 bg-red-500 text-white rounded active:bg-red-600 transition duration-150 min-w-16",
              buttonBlockStyle
            )}
            disabled={isLoading}
          >
            {isLoading ? <LoadingSpinnerInline /> : "삭제"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
